module.exports = __webpack_public_path__ + "img/F5-Network.e381989.svg";